<div class="form-container">
  <h2>{{(view == 'edit') ? 'Edit' : 'Create'}} Customer</h2>
  <div class="customer-form col-md-8 pl0">
    <alert></alert>
    <form [formGroup]="customerForm" (ngSubmit)="onSubmit()" novalidate>

      <!-- Assigned Partner -->
      <div class="form-row">
        <div class="col">
          <select class="form-control form-control-sm" formControlName="partner"
            [ngClass]="{ 'is-invalid': submitted && customerForm.controls.partner.errors }">
            <option value="" selected disabled>Partner*</option>
            @for (partner of partners; track partner) {
              <option [value]="partner.id">{{ partner.name }}</option>
            }
          </select>
          @if (submitted && customerForm.controls.partner.errors) {
            <div class="text-danger">
              @if (customerForm.controls.partner.errors.required) {
                <div>Partner is required</div>
              }
            </div>
          }
        </div>
      </div>

      <!-- CUSTOMER NAME -->
      <div class="form-row">
        <div class="col">
          <input type="text" class="form-control form-control-sm" formControlName="name"
            [ngClass]="{ 'is-invalid': submitted &amp;&amp; customerForm.controls.name.errors }"
            placeholder="Customer or Company*">
          @if (submitted && customerForm.controls.name.errors) {
            <div class="text-danger">
              @if (customerForm.controls.name.errors.required) {
                <div>Customer name is required</div>
              }
            </div>
          }
        </div>

        <!-- STATUS -->
        <div class="col">
          <select class="form-control form-control-sm" formControlName="status"
            [ngClass]="{ 'is-invalid': submitted &amp;&amp; customerForm.controls.status.errors }">
            <option value="" selected disabled>Status*</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
          @if (submitted && customerForm.controls.status.errors) {
            <div class="text-danger">
              @if (customerForm.controls.status.errors.required) {
                <div>Status is required</div>
              }
            </div>
          }
        </div>
      </div>

      <div class="form-row">
        <!-- EMAIL -->
        <div class="col">
          <input type="text" class="form-control form-control-sm" formControlName="email" placeholder="Email*"
            [ngClass]="{ 'is-invalid': submitted && customerForm.controls.email.errors }">
          @if (submitted && customerForm.controls.email.errors) {
            <div class="text-danger">
              @if (customerForm.controls.email.errors.required) {
                <div>Email is required</div>
              }
              @if (customerForm.controls.email.errors.email) {
                <div>Email is invlalid</div>
              }
            </div>
          }
        </div>
        <!-- PHONE -->
        <div class="col">
          <input type="text" class="form-control form-control-sm" placeholder="Phone number (ex. +1 555 222 4444)"
            formControlName="phone"
            [ngClass]="{ 'is-invalid': submitted &amp;&amp; customerForm.controls.phone.errors }">
          @if (submitted && customerForm.controls.phone.errors) {
            <div class="text-danger">
              @if (customerForm.controls.phone.errors.phone) {
                <div>Phone number is invalid (make sure to include country
                code)</div>
              }
            </div>
          }
        </div>
      </div>

      <!-- COUNTRY -->
      <div class="form-row">
        <div class="col">
          <select class="form-control form-control-sm" formControlName="country"
            [ngClass]="{ 'is-invalid': submitted &amp;&amp; customerForm.controls.country.errors }">
            <option value="" selected disabled>Country*</option>
            @for (country of countries; track country) {
              @if (country === null) {
                <option disabled value=""></option>
              }
              @if (country) {
                <option [value]="country">{{ country }}</option>
              }
            }
          </select>
          @if (submitted && customerForm.controls.country.errors) {
            <div class="text-danger">
              @if (customerForm.controls.country.errors.required) {
                <div>Country is required</div>
              }
            </div>
          }
        </div>

      </div>
      @if (!showReturnButton) {
        <div class="form-row">
          <button type="submit" class="btn btn-sm btn-primary"
          [disabled]="loading">{{(view == 'edit') ? 'Update' : 'Create'}} Customer</button>
          <button (click)="navigateBack()" [style.margin-left.px]="16" type="button"
          class="btn btn-sm btn-outline-secondary" [disabled]="loading">Cancel</button>
        </div>
      }
      @if (showReturnButton) {
        <div class="form-row">
          <button (click)="navigateBack()" type="button" class="btn btn-sm btn-primary">Done</button>
        </div>
      }

    </form>
  </div>
</div>